export const MODULES_FIELD_NAME: string = "modules";
